import Styles from './UploadsDrawer.module.scss'
import { UploadedFile } from '../UploadedFile'
import { useUploadsTab } from '../UploadsTabContext'
import { Carousel } from 'components/Carousel/Carousel'
import { SectionHeader } from './SectionHeader'
import { collectResults } from 'utils/query'
import { LoadingCarousel } from './LoadingCarousel'
import { useUploadedFiles } from 'hooks/queries/files/useUploadedFiles'
import { IMediaFile } from '../Types'

export const Uploads = () => {
  const { openPanel } = useUploadsTab()
  const uploadsQuery = useUploadedFiles()
  const uploads = collectResults(uploadsQuery, (data) => data.almanac_files) as IMediaFile[]

  if (uploadsQuery.isFetched && !uploads.length) {
    return null
  }

  return (
    <div>
      <SectionHeader
        title="Uploads"
        onPress={() => setTimeout(() => openPanel({ panel: 'uploads', panelProps: {} }), 100)}
      />
      <div className={Styles.sectionContainer}>
        {!uploadsQuery.isFetched && <LoadingCarousel />}
        {uploadsQuery.isFetched && (
          <Carousel slideGap={7}>
            {uploads.slice(0, 6).map((file, index) => (
              <div key={index} className={Styles.mediaFileContainer}>
                <UploadedFile key={file.id} file={file} size={{ height: 100, width: 100 }} />
              </div>
            ))}
          </Carousel>
        )}
      </div>
    </div>
  )
}
